import React from 'react';
import PropTypes from 'prop-types';
import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'components/Buttons/PrimaryCta';

const reloadPage = () => {
  window.location.reload();
};

const FulfillmentOptionNotAvailableNotNotification = ({ closeModal }) => {
  return (
    <NotificationModal
      title="Refresh Needed"
      body="Fulfillment options have changed. Please refresh the page to continue."
      onClose={closeModal}
    >
      <PrimaryCta label="Refresh" handleClick={reloadPage} fullWidth />
    </NotificationModal>
  );
};

FulfillmentOptionNotAvailableNotNotification.propTypes = {
  closeModal: PropTypes.func.isRequired
};

export default FulfillmentOptionNotAvailableNotNotification;
